export default "__VITE_ASSET__2dee143c__"